import { format } from 'date-fns/format';
import { FormattedMessage } from 'react-intl';

const formatDate = (value: string | Date) =>
  format(new Date(value), 'dd.MM.yyyy');

interface YourDataDeliveryDateProps {
  start: string | Date;
  end?: string | Date | null;
  product: string;
}

function YourDataDeliveryDate({
  start,
  end = null,
  product,
}: YourDataDeliveryDateProps) {
  const isDirectmarketing = product === 'direktvermarktung';

  if (!end) {
    return (
      <FormattedMessage
        id={
          !isDirectmarketing
            ? 'offerWizard.yourData.deliveryDateShort'
            : 'offerWizard.yourData.deliveryDateShort.directmarketing'
        }
        values={{
          start: formatDate(start),
        }}
      />
    );
  }

  return (
    <FormattedMessage
      id={
        !isDirectmarketing
          ? 'offerWizard.yourData.deliveryDate'
          : 'offerWizard.yourData.deliveryDate.directmarketing'
      }
      values={{
        start: formatDate(start),
        end: formatDate(end),
      }}
    />
  );
}

export default YourDataDeliveryDate;
